// import React, { useState } from 'react';

// const Navbar = ({ onButtonClick }) => {
//   const [activeButton, setActiveButton] = useState('');

//   const navbarStyle = {
//     position: 'sticky',
//     top: 0,
//     width: '100%',
//     height: '67px',
//     display: 'flex',
//     justifyContent: 'space-around',
//     alignItems: 'center',
//     background: '#ffffff1a',
//     gap: '0px',
//     opacity: 1,
//     zIndex: 1000, // Ensure the navbar stays on top
//   };

//   const buttonStyle = (buttonName) => ({
//     background: activeButton === buttonName ? 'rgba(255, 255, 255, 0.3)' : 'none',
//     border: 'none',
//     color: 'white',
//     fontSize: '12px',
//     fontFamily: 'Inter',
//     fontWeight: 500,
//     lineHeight: '14.52px',
//     textAlign: 'center',
//     cursor: 'pointer',
//     padding: '10px 20px',
//     borderRadius: '5px',
//     display: 'flex',
//     flexDirection: 'column',
//     alignItems: 'center',
//   });

//   const logoStyle = {
//     width: '23px',
//     height: '24px',
//     marginBottom: '5px',
//   };

//   const handleButtonClick = (buttonName) => {
//     setActiveButton(buttonName);
//     onButtonClick(buttonName);
//   };

//   return (
//     <div style={navbarStyle}>
//       <button style={buttonStyle('Upload Custom Sale')} onClick={() => handleButtonClick('Upload Custom Sale')}>
//         <img src="./images/upload.png" alt="Upload Custom Sale" style={logoStyle} />
//         Upload Custom Sale
//       </button>
//       <button style={buttonStyle('Build or Review Blueprint for SE')} onClick={() => handleButtonClick('Build or Review Blueprint for SE')}>
//         <img src="./images/Blueprint.png" alt="Build or Review Blueprint for SE" style={logoStyle} />
//         Build or Review Blueprint for SE
//       </button>
//       <button style={buttonStyle('Build or Review Account Plan')} onClick={() => handleButtonClick('Build or Review Account Plan')}>
//         <img src="./images/todo.png" alt="Build or Review Account Plan" style={logoStyle} />
//         Build or Review Account Plan
//       </button>
//       <button style={buttonStyle('Evaluate Opportunity with MEDDICC Score')} onClick={() => handleButtonClick('Evaluate Opportunity with MEDDICC Score')}>
//         <img src="./images/popular.png" alt="Evaluate Opportunity with MEDDICC Score" style={logoStyle} />
//         Evaluate Opportunity with MEDDICC Score
//       </button>
//       <button style={buttonStyle('Ask for Next Steps')} onClick={() => handleButtonClick('Ask for Next Steps')}>
//         <img src="./images/popular.png" alt="Ask for Next Steps" style={logoStyle} />
//         Ask for Next Steps
//       </button>
//       <button style={buttonStyle('Log out')} onClick={() => handleButtonClick('Log out')}>
//         <img src="./images/logout.png" alt="Log out" style={logoStyle} />
//         Log out
//       </button>
//     </div>
//   );
// };

// export default Navbar;
// src/components/Navbar.js
// src/components/Navbar.js
// src/components/Navbar.js
import React, { useState } from 'react';
import './Navbar.css'; // Ensure you import the CSS for styling

const Navbar = ({ onButtonClick, onFileUpload }) => {
  const [activeButton, setActiveButton] = useState('');

  const handleButtonClick = (buttonName) => {
    setActiveButton(buttonName);
    onButtonClick(buttonName);
  };

  const handleFileUpload = (e) => {
    e.preventDefault();
    const fileInput = document.getElementById('navbar-file-upload');
    fileInput.click();
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      onFileUpload(file);
    }
  };

  return (
    <div className="navbar">
      <input
        type="file"
        id="navbar-file-upload"
        style={{ display: 'none' }}
        onChange={handleFileChange}
      />
      <button 
        className={`navbar-button ${activeButton === 'Upload Custom Sale' ? 'active' : ''}`} 
        onClick={handleFileUpload}
      >
        <img src="./images/upload.png" alt="Upload Custom Sale" className="navbar-logo" />
        Upload Custom Sale
      </button>
      <button 
        className={`navbar-button ${activeButton === 'Build or Review Blueprint for SE' ? 'active' : ''}`} 
        onClick={() => handleButtonClick('Build or Review Blueprint for SE')}
      >
        <img src="./images/Blueprint.png" alt="Build or Review Blueprint for SE" className="navbar-logo" />
        Build or Review Blueprint for SE
      </button>
      <button 
        className={`navbar-button ${activeButton === 'Build or Review Account Plan' ? 'active' : ''}`} 
        onClick={() => handleButtonClick('Build or Review Account Plan')}
      >
        <img src="./images/todo.png" alt="Build or Review Account Plan" className="navbar-logo" />
        Build or Review Account Plan
      </button>
      <button 
        className={`navbar-button ${activeButton === 'Evaluate Opportunity with MEDDICC Score' ? 'active' : ''}`} 
        onClick={() => handleButtonClick('Evaluate Opportunity with MEDDICC Score')}
      >
        <img src="./images/popular.png" alt="Evaluate Opportunity with MEDDICC Score" className="navbar-logo" />
        Evaluate Opportunity with MEDDICC Score
      </button>
      <button 
        className={`navbar-button ${activeButton === 'Ask for Next Steps' ? 'active' : ''}`} 
        onClick={() => handleButtonClick('Ask for Next Steps')}
      >
        <img src="./images/popular.png" alt="Ask for Next Steps" className="navbar-logo" />
        Ask for Next Steps
      </button>
      <button 
        className={`navbar-button ${activeButton === 'Log out' ? 'active' : ''}`} 
        onClick={() => handleButtonClick('Log out')}
      >
        <img src="./images/logout.png" alt="Log out" className="navbar-logo" />
        Log out
      </button>
    </div>
  );
};

export default Navbar;
